import Vue from 'vue'
import * as searchModule from './search'
import * as autocompleteSetters from './store/autocompleteStore-setters'
import * as autocompleteGetters from './store/autocompleteStore-getters'
import * as searchSetters from './store/searchStore-setters'

//getting the suggestions list
const getSuggestions = (langparam, params) => {
    let arrayParams = Object.values(langparam)
    let parameter = _arraySearchParam(arrayParams, params.param)

    if (!autocompleteGetters.getIsActiveSuggestions()) {
        autocompleteSetters.loadSuggestions({ params: params, parameter: parameter})
    }
}

//setting the suggestion into state by mouse clicking on anchor
const setSuggestion = (params, value) => {
    let newParamsFromSuggestion = { key: value, param: params.param }
    searchSetters.setNewSearchParamsKey(value)
    searchModule.newSearchQuery(newParamsFromSuggestion)
}

//highlights the letters of the suggestion
const highlightLetters = (suggestion, query) => {
    return suggestion.replace(query, '<span class=\'suggestion__highlight\'>' + query + '</span>')
}

//getting the pressed key
const keyHandler = (e, list) => {
    if ((e.keyCode == 40 || e.keyCode == 38) && list.length > 0) {
        e.preventDefault()
        autocompleteSetters.setIsActiveSuggestions(true)

        let inc = e.keyCode == 40 ? 1 : -1,
            moveOld = (!autocompleteGetters.getActiveMouse()) ? _searchListActiveItem(list) : _mouseListActiveItem(),
            moveNew = parseInt(moveOld) + inc,
            firstUpDown = e.keyCode == 40 ? 0 : list.length - 1

        if (moveOld && list[moveNew]) {
            list[moveOld].classList.remove('suggestion__active')
            list[moveNew].classList.add('suggestion__active')
            searchSetters.setNewSearchParamsKey(list[moveNew].text)
        } else {
            if (_searchListActiveItem(list)) {
                list[_searchListActiveItem(list)].classList.remove('suggestion__active')
            }

            list[firstUpDown].classList.add("suggestion__active");
            searchSetters.setNewSearchParamsKey(list[firstUpDown].text)
        }

    } else {
        autocompleteSetters.setIsActiveAutocompleteDropdown(false)
        autocompleteSetters.setIsActiveSuggestions(false)
    }
}

const setAutocompleteDropdown = (b) => {
    autocompleteSetters.setIsActiveAutocompleteDropdown(b)
}

//mouse actions on autocomplete list
const listMouseEnter = (e,list) => {
    if (_searchListActiveItem(list)) {
        list[_searchListActiveItem(list)].classList.remove('suggestion__active')
    }

    autocompleteSetters.setActiveMouse(e.target.dataset.autocomplete)
    e.target.classList.add('suggestion__active')
}

const listMouseLeave = (e) => {
    e.target.classList.remove('suggestion__active')
}

const _mouseListActiveItem = () => {
    let number = autocompleteGetters.getActiveMouse()
    autocompleteSetters.setActiveMouse('')
    return number
}

//search list for active item
const _searchListActiveItem = (list) => {
    for (let i in list) {
        if (list[i].classList.contains('suggestion__active')) {
            return i
        }
    }
}

//getting search param array for autocomplete
const _arraySearchParam = (arr, val) => {
    let index

    for (let i in arr) {
        if (arr[i]['val'] == val) {
            index = i
        }
    }

    return arr[index]['autocomplete']
}


export {
    getSuggestions,
    setSuggestion,
    highlightLetters,
    keyHandler,
    setAutocompleteDropdown,
    listMouseEnter,
    listMouseLeave
}



// WEBPACK FOOTER //
// ./src/scripts/modules/autocomplete.js